import React from 'react';
import axios from 'axios';
import {Button, message, Row, Col, Checkbox, Modal} from 'antd';
import TemplateExterno from '../interfaz/TemplateExterno'
import {connect} from 'react-redux';
import exitoDeclinacion from '../../img/Declinacion.png';
import Logout from '../../ApplicationResources';

class ExitoDeclinacion extends React.Component{

    constructor(props) {    
        super(props);  
        
        this.form = this.props.form;
    }

    cerrarSesion = () => {
        this.props.history.goBack();
	}

    regresar = () =>{
        const datosAspirante = this.props.datosAspirante || {};
        const datosUsuario = this.props.datosUsuario || {};
        console.log("ESTATUS ",datosAspirante.estatusRegistro);

        if(datosUsuario.origenRegistro === 2 && datosUsuario.tipoUsuario === 'E' &&
          (datosAspirante.estatusRegistro === 1 || datosAspirante.estatusRegistro === 2)){
                this.props.history.push('/cargaDocumentos');
        }else{
            if((datosAspirante.estatusRegistro === 1 && datosAspirante.bPlatica === null) || 
               (datosAspirante.estatusRegistro === 2 && datosAspirante.bObservacion === 1)){
                this.props.history.push('/cargaDocumentos');
            }
            else if(datosAspirante.estatusRegistro === 2 && datosAspirante.bPlatica === null){
                this.props.history.push('/platica_induccion');
            }
            else if(datosAspirante.estatusRegistro === 2 && datosAspirante.bPlatica === 0){
                this.props.history.push('/finalizado');
            }else if(datosAspirante.estatusRegistro === 4 || datosAspirante.estatusRegistro === 5){
                this.props.history.push('/solicitud_declinada');
            }
        }
    }

    render() {
        return(
            <TemplateExterno enlaces={false}
            contenidoExpandido={true}>
                <div className="exito_container">
                    <div style={{'height': '100%', 'width':'85%', 'textAlign':'center'}}>
                        <img src={exitoDeclinacion} alt="ExitoDeclinacion" width="90%" height="50%"/>
                    
                    <br></br><br></br>
                    
                        <Button className="botonesModal" style={{width: 150}} onClick={() => this.cerrarSesion()}> Cerrar sesión </Button>
                    </div>
                </div>
            </TemplateExterno>
        );
    }

}

const mapStateToProps = state => {
    var datosAspirante;
    var datosUsuario;

    if (state.user.datosAspirante)
        datosAspirante = state.user.datosAspirante;
        datosUsuario = state.user.currentUser;

    return {
        datosAspirante: datosAspirante,
        datosUsuario: datosUsuario,
    };
}

export default connect(mapStateToProps)(ExitoDeclinacion);